import React from 'react';

const fmtCurrency = (n) => '$' + new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 }).format(Number.isFinite(n) ? n : 0);
const fmtPercent = (n) => new Intl.NumberFormat(undefined, { style: 'percent', maximumFractionDigits: 1 }).format(n || 0);

class ValueGapQuestion extends React.Component {
  componentDidMount() { if (this.headingRef) this.headingRef.focus(); }
  componentDidUpdate(prevProps) { if (prevProps.step !== this.props.step && this.headingRef) this.headingRef.focus(); }

  renderStep0() {
    const { wealth, onNext } = this.props;
    return (
      <div className="flex justify-center bg-succession-surface px-4 pt-2 pb-6">
        <div className="w-full max-w-3xl">
          <div className="mb-4">
            <button type="button" onClick={onNext} className="text-succession-primary hover:underline" aria-label="Skip"> </button>
          </div>
          <h1 className="text-3xl md:text-4xl font-semibold text-succession-foreground mb-2" tabIndex="-1" ref={(el) => (this.headingRef = el)}>Confirm your Wealth Gap</h1>
          <p className="text-succession-muted mb-4">As an owner you want {fmtCurrency(wealth.X)} as your Wealth Goal. This translates into {fmtCurrency(wealth.Y)} annually. Is this correct?</p>
          <div className="mt-4 flex gap-3">
            <button type="button" className="bg-succession-primary text-white px-4 py-2 rounded" onClick={onNext}>Yes</button>
            <a href="/succession/readiness/wealth-gap" className="px-4 py-2 rounded border border-succession-border text-succession-foreground hover:bg-white">No, retake Wealth Gap</a>
          </div>
        </div>
      </div>
    );
  }

  renderStep1() {
    const { totals, onNext, onBack } = this.props;
    return (
      <div className="flex justify-center bg-succession-surface px-4 pt-2 pb-6">
        <div className="w-full max-w-3xl">
          <div className="mb-4">
            <button type="button" onClick={onBack} className="text-succession-primary hover:underline" aria-label="Go back">← Back</button>
          </div>
          <h1 className="text-3xl md:text-4xl font-semibold text-succession-foreground mb-2" tabIndex="-1" ref={(el) => (this.headingRef = el)}>Confirm your Recasted EBITDA</h1>
          <p className="text-succession-muted mb-4">In the Profit Gap survey you indicated your normalized / recasted EBITDA was {fmtCurrency(totals.recasted_ebitda)}. Is this correct?</p>
          <div className="mt-4 flex gap-3">
            <button type="button" className="bg-succession-primary text-white px-4 py-2 rounded" onClick={onNext}>Yes</button>
            <a href="/succession/readiness/profit-gap" className="px-4 py-2 rounded border border-succession-border text-succession-foreground hover:bg-white">No, retake Profit Gap</a>
          </div>
        </div>
      </div>
    );
  }

  renderStep2() {
    const { selection, totals, onNext, onBack } = this.props;
    return (
      <div className="flex justify-center bg-succession-surface px-4 pt-2 pb-6">
        <div className="w-full max-w-3xl">
          <div className="mb-4">
            <button type="button" onClick={onBack} className="text-succession-primary hover:underline" aria-label="Go back">← Back</button>
          </div>
          <h1 className="text-3xl md:text-4xl font-semibold text-succession-foreground mb-2" tabIndex="-1" ref={(el) => (this.headingRef = el)}>Your Current (Simplified) Business Value</h1>
          <p className="text-succession-muted mb-2">We selected a multiple of <b>{selection.multiple.toFixed(2)}x</b> (position {selection.bucket + 1}/6) based on your diagnostic: Readiness {fmtPercent(selection.r)} and Attractiveness {fmtPercent(selection.a)}.</p>
          <p className="text-succession-muted mb-4">Using your recasted EBITDA {fmtCurrency(totals.recasted_ebitda)} and the selected multiple, we’ll compute your simplified value next.</p>
          <div className="mt-4 flex gap-3">
            <button type="button" className="bg-succession-primary text-white px-4 py-2 rounded" onClick={onNext}>Continue</button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { step } = this.props;
    if (step === 0) return this.renderStep0();
    if (step === 1) return this.renderStep1();
    if (step === 2) return this.renderStep2();
    return null;
  }
}

export default ValueGapQuestion;


